import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SubscriptionRequest } from '../model/subscription-request';
import { SubscriptionPreview } from '../model/subscription-preview';
import { HttpUtil } from '../../../shared/util/http.util';
import { ApplicationConfig } from '../../../core/config/application.config';

@Injectable({ providedIn: 'root' })
export class SubscriptionApiService {
  constructor(private readonly httpUtil: HttpUtil) {}

  public createSubscription(request: SubscriptionRequest): Observable<void> {
    return this.httpUtil
      .post(`${ApplicationConfig.apiUrl}/subscriptions`, request)
      .pipe(
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

  public previewSubscription(
    productName: string,
    couponCode: string | null,
    referralCode: string | null
  ): Observable<SubscriptionPreview> {
    const params: Record<string, string> = { productName };
    if (couponCode) {
      params['couponCode'] = couponCode;
    }
    if (referralCode) {
      params['referralCode'] = referralCode;
    }

    return this.httpUtil.get(
      `${ApplicationConfig.apiUrl}/subscriptions/preview`,
      params
    );
  }
}
